import DashboardLayout from '../layout'
import Header from '../header/Header'
import AiHsCalculator from './AiHsCalculator'
import AiHsTermsPopup from './AiHsTermsPopup'


const AiHsCalculatorPage = () => {
    return (
        <DashboardLayout>
            <div className="w-full h-full">
                <Header title="HS Compass™ by OUS" />
                <div className="h-full  w-full flex items-start justify-center">
                    <div className="w-full h-full max-w-[74vw]">
                        <AiHsCalculator />
                    </div>
                </div>
            </div>

            <AiHsTermsPopup />
        </DashboardLayout>
    )
}

export default AiHsCalculatorPage
